'use client'
import { Fragment } from 'react'
import { Box } from '@shipt/design-system-layouts'
import { getCMSShelfLoader } from '@/features/cms/components/CMS/CMSLoaders'
import { VisuallyHidden } from '@/features/shared/elements/VisuallyHidden'
import { range } from '@/features/shared/utils/range'

const SHELF_COUNT = 6

/**
 * The pages-router deals page body while its shelves are still in flight.
 *
 * Six `product_shelf` skeletons rather than a spinner: a deals page is a stack
 * of carousels, so shelf-shaped placeholders reserve roughly the height the
 * real shelves take and keep the swap from shoving the page around.
 */
export const DealsLoadingState = () => {
  return (
    <Box marginTop={{ base: 'lg', md: 'xl' }}>
      <VisuallyHidden>Checking for available deals</VisuallyHidden>
      {range(SHELF_COUNT).map((index) => (
        <Fragment key={index}>{getCMSShelfLoader('product_shelf')}</Fragment>
      ))}
    </Box>
  )
}
